import request from '@/config/axios'

export const initOrgData = (data) => {
  return request.post({
    baseUrl: 'm2i',
    url: '/system/org/initialize',
    data: data
  })
}

// 获取站点参数
export const GetKeyParams = (params) => {
  return request.get({
    baseUrl: 'm2i',
    url: '/org/node/keyparameters',
    params: params
  })
}

// 设定站点参数
export const SetKeyParams = (data) => {
  return request.post({
    baseUrl: 'm2i',
    url: '/org/node/keyparameters',
    data: data
  })
}

export const GetGeneralSettings = (params) => {
  return request.get({
    baseUrl: 'm2i',
    url: '/system/general/setting',
    params: params
  })
}

export const SetGeneralSettings = (data) => {
  return request.post({
    baseUrl: 'm2i',
    url: '/system/general/setting',
    data: data
  })
}

export const GetLang = (params) => {
  return request.get({
    url: '/i18n-data',
    baseUrl:'m2i',
    params: params,
    timeout: 5000
  })
}

export const RegisterLang = (data) => {
  return request.post({
    url: '/i18n-data',
    baseUrl:'m2i',
    data: data,
    timeout: 5000
  })
}